// extracted by mini-css-extract-plugin
module.exports = {"buttonCol":"ProductCatalogueAddToCart_buttonCol__p9e9K","buttonRow":"ProductCatalogueAddToCart_buttonRow__yyq1e","orderButton":"ProductCatalogueAddToCart_orderButton__2xQXM"};